import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';
import { Electricity, ElectricityAction, ElectricityOut } from '../models/Electricity';

export default class ElectricityApi {

    private http: HTTPClient;
    private rootPath: string;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
    }

    public async getElectricities(pk_cuaa: number, paging: PagingParams, filter: string | null): Promise<PagedResults<Electricity>>{
        const res = await this.http.get(`${this.rootPath}/v1/warehouse/subjects/${pk_cuaa}/electricities`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                filter: filter ? `^item_name like ${filter.toUpperCase()}` : undefined
            }
        })

        return res.data;
    }

    public async getElectricityById(pk_cuaa: number, id: number): Promise<any>{
        const res = await this.http.get(`${this.rootPath}/v1/warehouse/subjects/${pk_cuaa}/electricities`, {
            params: {
                filter:`item_id eq ${id}`
            }
        })

        return res;
    }

    public async addActionElectricity(pk_cuaa: number, campaign: number, execution_id: number, newElectricity: ElectricityOut): Promise<ElectricityAction> {
        const res = await this.http.post(`${this.rootPath}/v1/plots/subjects/${pk_cuaa}/${campaign}/actions/${execution_id}/electricities`, newElectricity);
        return res.data;
    }

    public async deleteActionElectricity(pk_cuaa: number, campaign: number, execution_id: number, execution_resource_id: number): Promise<ElectricityAction> {
        const res = await this.http.delete(`${this.rootPath}/v1/plots/subjects/${pk_cuaa}/${campaign}/actions/${execution_id}/electricities/${execution_resource_id}`);
        return res.data;
    }

    // public async addActivityElectricity(pk_cuaa: number, campaign: number, action_id: number, newElectricity: ElectricityOut): Promise<ActivityElectricityAction> {
    //     const res = await this.http.post(`${this.rootPath}/v1/plots/subjects/${pk_cuaa}/${campaign}/activities/${action_id}/electricities`, newElectricity);
    //     return res.data;
    // }

    // public async deleteActivityElectricity(pk_cuaa: number, campaign: number, action_id: number, execution_resource_id: number): Promise<ActivityElectricityAction> {
    //     const res = await this.http.delete(`${this.rootPath}/v1/plots/subjects/${pk_cuaa}/${campaign}/activities/${action_id}/electricities/${execution_resource_id}`);
    //     return res.data;
    // }

}
